import { useApp } from '../../state/AppContext';
import Icon from '../../lib/Icon';
import { fmt, badge, zebra } from '../../lib/format';
import { card, Th, Chip } from '../../lib/ui';

export default function Po() {
  const { go, set, L } = useApp();

  const poData = [
    { id: 'PO-2026-0041', desc: 'Fleet Vehicle Insurance — Class 1, Policy Period 2026-2027', by: 'Maria B.', sup: 'Apex Insurance Co.', value: 4620000, issued: '2026-06-22', due: '2026-07-01', status: 'Active', match: 'Variance', doa: 'DOA Director' },
    { id: 'PO-2026-0035', desc: 'Spare Parts — Q2 Batch (Engine & Transmission)', by: 'Sam K.', sup: 'ACME Union Motors Ltd.', value: 12100000, issued: '2026-06-15', due: '2026-06-30', status: 'Pending GR', match: 'Pending GR', doa: 'DOA Executive' },
    { id: 'PO-2026-0048', desc: 'Tire & Wheel Replacement — Q3 Fleet Program', by: 'Sam K.', sup: 'GeoTrack Solutions', value: 780000, issued: '2026-06-22', due: '2026-07-10', status: 'Pending Approval', match: 'Pending', doa: 'Procurement Director' },
    { id: 'PO-2026-0047', desc: 'Property All-Risk Insurance', by: 'Maria B.', sup: 'Apex Insurance Co.', value: 5400000, issued: '2026-06-21', due: '2026-07-05', status: 'Pending Approval', match: 'Pending', doa: 'Executive Committee' },
    { id: 'PO-2026-0046', desc: 'Office Equipment Insurance Renewal', by: 'Paula W.', sup: 'Summit Insurance Ltd.', value: 95000, issued: '2026-06-20', due: '2026-07-02', status: 'Pending Approval', match: 'Pending', doa: 'Procurement Officer' },
    { id: 'PO-2026-0031', desc: 'Maintenance Services — Factory Equipment', by: 'Paula W.', sup: 'Crestline Insurance', value: 2050000, issued: '2026-05-30', due: '2026-06-20', status: 'Active', match: 'Matched', doa: 'DOA Executive' },
  ];
  const poRows = poData.map((p, i) => {
    const b = badge(p.status), m = badge(p.match);
    return { ...p, value: fmt(p.value), zebra: zebra(i), stBg: b.bg, stFg: b.fg, mBg: m.bg, mFg: m.fg, pending: p.status === 'Pending Approval' };
  });
  const poFooter = L('Showing 6 of 10 POs · Total value: $48.75M', 'แสดง 6 จาก 10 PO · มูลค่ารวม: $48.75M');

  return (
    <>
      <div style={{ display: 'flex', gap: 10, marginBottom: 16, alignItems: 'center' }}>
        <div style={{ position: 'relative', flex: 1, maxWidth: 320 }}>
          <Icon name="search" style={{ position: 'absolute', left: 11, top: '50%', transform: 'translateY(-50%)', color: 'var(--color-fg-3)', fontSize: 16 }} />
          <input placeholder={L('Search PO number…', 'ค้นหาเลขที่ PO…')} style={{ width: '100%', padding: '9px 12px 9px 34px', border: '1px solid var(--color-border-strong)', borderRadius: 'var(--radius-sm)', background: 'var(--color-white)' }} />
        </div>
        <select style={{ padding: '9px 12px', border: '1px solid var(--color-border-strong)', borderRadius: 'var(--radius-sm)', background: 'var(--color-white)' }}>
          <option>{L('All statuses', 'ทุกสถานะ')}</option>
          <option>{L('Active', 'ใช้งาน')}</option>
          <option>{L('Pending Approval', 'รออนุมัติ')}</option>
          <option>{L('Pending GR', 'รอรับสินค้า')}</option>
        </select>
        <div style={{ flex: 1 }} />
        <button className="hv-ink" style={{ display: 'flex', alignItems: 'center', gap: 7, padding: '9px 14px', border: '1px solid var(--color-border-strong)', borderRadius: 'var(--radius-sm)', fontSize: 13, fontWeight: 600, background: 'var(--color-white)' }}>
          <Icon name="download" />{L('Export', 'ส่งออก')}
        </button>
      </div>
      <div style={{ ...card, overflow: 'auto' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13, minWidth: 1000 }}>
          <thead>
            <tr style={{ background: 'var(--color-mist)', borderBottom: '1px solid var(--color-border)' }}>
              <Th>{L('PO Number', 'เลขที่ PO')}</Th>
              <Th>{L('Description', 'รายละเอียด')}</Th>
              <Th>{L('Supplier', 'ซัพพลายเออร์')}</Th>
              <Th align="right">{L('Value', 'มูลค่า')}</Th>
              <Th>{L('Issued', 'วันที่ออก')}</Th>
              <Th>{L('Status', 'สถานะ')}</Th>
              <Th>{L('3-Way Match', 'การจับคู่ 3 ทาง')}</Th>
              <Th>{L('DOA Level', 'ระดับ DOA')}</Th>
              <Th align="right">{L('Actions', 'การดำเนินการ')}</Th>
            </tr>
          </thead>
          <tbody>
            {poRows.map((p) => (
              <tr key={p.id} style={{ borderBottom: '1px solid var(--color-border)', background: p.zebra }}>
                <td style={{ padding: '12px 14px', fontFamily: 'var(--font-mono)', fontWeight: 600 }}>{p.id}</td>
                <td style={{ padding: '12px 14px' }}>
                  <div style={{ fontWeight: 600 }}>{p.desc}</div>
                  <div style={{ fontSize: 11, color: 'var(--color-fg-3)' }}>{L('By', 'โดย')}: {p.by}</div>
                </td>
                <td style={{ padding: '12px 14px', color: 'var(--color-fg-2)' }}>{p.sup}</td>
                <td style={{ padding: '12px 14px', textAlign: 'right', fontFamily: 'var(--font-mono)', fontWeight: 600 }}>{p.value}</td>
                <td style={{ padding: '12px 14px', fontFamily: 'var(--font-mono)', color: 'var(--color-fg-2)' }}>{p.issued}</td>
                <td style={{ padding: '12px 14px' }}><Chip bg={p.stBg} fg={p.stFg} dot>{p.status}</Chip></td>
                <td style={{ padding: '12px 14px' }}><Chip bg={p.mBg} fg={p.mFg}>{p.match}</Chip></td>
                <td style={{ padding: '12px 14px', color: 'var(--color-fg-2)', fontSize: 12 }}>{p.doa}</td>
                <td style={{ padding: '12px 14px', textAlign: 'right', whiteSpace: 'nowrap' }}>
                  {p.pending ? (
                    <button onClick={() => { set({ openedPo: { id: p.id, desc: p.desc, sup: p.sup, value: p.value, doa: p.doa, pending: true } }); go('podetail'); }} className="hv-primary" style={{ fontSize: 12, fontWeight: 600, padding: '6px 12px', borderRadius: 'var(--radius-sm)', background: 'var(--color-primary)', color: '#fff' }}>{L('Open', 'เปิด')}</button>
                  ) : (
                    <button onClick={() => { set({ openedPo: null }); go('podetail'); }} className="hv-ink" style={{ fontSize: 12, fontWeight: 600, padding: '6px 12px', borderRadius: 'var(--radius-sm)', border: '1px solid var(--color-border-strong)', background: 'var(--color-white)', color: 'var(--color-fg-1)' }}>{L('View', 'ดู')}</button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <div style={{ padding: '12px 16px', fontSize: 12, color: 'var(--color-fg-3)', borderTop: '1px solid var(--color-border)' }}>{poFooter}</div>
      </div>
    </>
  );
}
